import { ModuleProps, ModuleStatus } from 'pages/cadastro/permissoes/types';

export const getEnabledCount = (module: ModuleProps) => module.permissoes.filter((p) => !!p.fgPermiteAcesso).length;

/**
 * Retorna o status do módulo
 */
export const getModuleStatus = (enabled: number, total: number) => {
    let label = 'Acesso total';
    let color = 'success.main';
    let status: ModuleStatus = 'all';

    if (enabled === 0) {
        status = 'none';
        label = 'Nenhuma permissão';
        color = 'text.disabled';
    } else if (enabled !== total) {
        status = 'partial';
        label = `${enabled}/${total} permissões`;
        color = 'warning.main';
    }

    return {
        status,
        label,
        color,
    };
};
